import { SubscriptionRegistry, } from "../Observable/mod.js";
import { BasicReference } from "./BasicReference.js";
function getDependencyValues(options) {
    const { dependencies } = options;
    const values = [];
    for (const dep of dependencies) {
        values.push(dep.value);
    }
    return values;
}
function computeValue(options) {
    const { compute } = options;
    const values = getDependencyValues(options);
    // eslint-disable-next-line prefer-spread
    return compute.apply(null, values);
}
/**
 * @internal scope: package
 */
export class ReferenceCompute extends BasicReference {
    /**
     * @remarks
     *
     * Serves a dual purpose:
     * 1. It holds the options used to create the reference.
     * 2. It retains a strong reference to the dependencies,
     *   ensuring they are not garbage collected while this reference exists.
     *
     * @internal scope: package
     */
    #options;
    /**
     * @internal scope: package
     */
    #updatePending = false;
    /**
     * @internal scope: package
     */
    #subscriptionRegistry = new SubscriptionRegistry();
    constructor(options) {
        const { comparator, onUpdate } = options;
        const initialValue = computeValue(options);
        super({ initialValue, onUpdate, comparator });
        this.#options = options;
        // Subscribe to dependencies as soon as the object is created.
        this.#subscribeToDependencies();
    }
    #dependencyObserver = {
        next: () => {
            if (this.#updatePending)
                return;
            this.#updatePending = true;
            queueMicrotask(() => {
                this.#updatePending = false;
                // Computation is performed just before the value is set,
                // so that the value is computed only once per update,
                // even if multiple dependencies have changed.
                // This ensures that the value is up-to-date.
                const value = computeValue(this.#options);
                this.set(value);
            });
        },
    };
    subscription = {
        subscriber: this.#dependencyObserver,
        /**
         * @detachable
         */
        unsubscribe: () => {
            this.#subscriptionRegistry.unsubscribeAll();
        },
    };
    #subscribeToDependencies() {
        const { dependencies } = this.#options;
        for (const key in dependencies) {
            const subscription = dependencies[key].subscribe(this.#dependencyObserver);
            this.#subscriptionRegistry.add(subscription);
        }
    }
}
